import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import HomeRoute from "./Routes/HomeRoute";
import VideoRoute from "./Routes/VideoRoute";
import LoginRoute from "./Routes/LoginRoute";
import Redirect from "./Routes/Redirect";

const App = () => {
  const router = createBrowserRouter([
    {
      path:"/subscribe",element:<LoginRoute />
    },
    {
      path: "/",
      element: <HomeRoute />,
    },
    {
      path: "/redirect",
      element: <Redirect />,
    },
    {
      path:"/videos/:id",element:<VideoRoute />
    },
  ]);
  return <RouterProvider router={router}></RouterProvider>
};

export default App;
